import { runningPresentation } from "../lib/runningPresentation";
import RunningCoach from "./RunningCoach";
import TrainingStructureSummary from "./TrainingStructureSummary";
import { hasTrainingStructure, trainingDisplayItem } from "../lib/trainingCompatibility";
import "./RunningTrainingSummary.css";

export default function RunningTrainingSummary({ item, lang = "de", coachEnabled = false, playerId }) {
  if (hasTrainingStructure(item)) return <TrainingStructureSummary item={item} lang={lang} coachEnabled={coachEnabled} playerId={playerId} />;
  item = trainingDisplayItem(item, lang);
  const presentation = runningPresentation(item, lang);
  if (!presentation) return null;
  const { copy, profile, profileNotes, instruction, steps, summary, comparison } = presentation;
  const muted = { color: "var(--pc-muted)" };
  return <section className="pc-running-summary min-w-0" data-testid="running-training-summary">
    {profile.length > 0 && <section aria-label={copy.profile}>
      <dl className="pc-running-profile" data-testid="running-effort-profile">
        {profile.map(({ key, value, hint, missingLabel }) => <div key={key} className="pc-running-profile-card" data-profile={key}>
          <dt>{copy[key]}</dt>
          <dd><span className={`pc-running-profile-value${String(value ?? "").length > 9 ? " pc-running-profile-value--compact" : ""}`} aria-label={missingLabel}>
            {value?.length > 15 && value.includes("–")
              ? <><span>{value.split("–")[0]}–</span><wbr /><span>{value.split("–")[1]}</span></>
              : value ?? "—"}
          </span>
            <span className="pc-running-profile-hint">{hint || (value == null ? "—" : key === "heart" ? copy.target : copy.percentUnit)}</span>
          </dd>
        </div>)}
      </dl>
      {profileNotes.map((note) => <p key={note} className="text-xs mt-2" style={{ ...muted, overflowWrap: "anywhere" }}>{note}</p>)}
    </section>}
    {comparison && <section className="text-sm space-y-1" data-testid="running-load-comparison">
      <p>{copy.planned}: {comparison.planned}/5 · {copy.actual}: {comparison.actual}/5</p>
      <p className="text-xs" style={muted}>{comparison.label}</p>
    </section>}
    {(steps.length > 0 || coachEnabled) && <section aria-label={copy.flow}>
      {coachEnabled && playerId && item.id ? <RunningCoach key={`${playerId}:${item.id}`} item={item} playerId={playerId} lang={lang} title={copy.flow} />
        : <h4 className="text-sm font-semibold mb-3">{copy.flow}</h4>}
      <ol className="space-y-3" data-testid="running-session-flow">
        {steps.map(({ key, value }, index) => <li key={key} className="flex items-start gap-3 min-w-0">
          <span aria-hidden="true" className="flex items-center justify-center rounded-full shrink-0 w-6 h-6 text-xs font-semibold"
            style={{ background: "var(--pc-cyan-dim)", color: "var(--pc-cyan)" }}>{index + 1}</span>
          <div className="min-w-0 text-sm leading-relaxed" style={{ overflowWrap: "anywhere" }}>
            <p className="font-semibold">{copy[key]}</p><p style={muted}>{value}</p>
          </div>
        </li>)}
      </ol>
    </section>}
    <section aria-label={copy.summary}>
      <h4 className="text-sm font-semibold mb-2">{copy.summary}</h4>
      <p className="text-sm leading-relaxed" style={{ ...muted, overflowWrap: "anywhere" }}>{summary}</p>
      {instruction && <p className="text-sm leading-relaxed mt-2" style={{ ...muted, overflowWrap: "anywhere" }}>{instruction}</p>}
    </section>
  </section>;
}
